export default theme => ({
  sourceThumbnail: {
    maxWidth: 900,
  },
});
